/*
 * Confidential and Proprietary.
 * Do not distribute without 1-800-Flowers.com, Inc. consent.
 * Copyright 1-800-Flowers.com, Inc. 2019. All rights reserved.
 */

import React from 'react';
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/core/styles';
import Typography from '@material-ui/core/Typography';
import { sanitizeContent } from '../../../../../../../lib/sanitize';

const styles = (theme) => ({
    errorMsg: {
        margin: '0',
        textAlign: 'left',
        marginTop: '8px',
        minHeight: '1em',
        fontFamily: 'Helvetica, Arial, Verdana, sans-serif',
        fontSize: '1em',
        lineHeight: '1em',
        color: theme.palette.error.main,
    },
    smallText: {
        fontSize: '0.75em',
    },
    mediumText: {
        fontSize: '1em',
    },
});

const InlineErrorMessage = ({ classes, fontSize, error }) => {
    const classFontSize = (fontSize === 'medium') ? classes.mediumText : classes.smallText;

    const formatStringValue = (str) => {
        if (str && str.length > 0) {
            return str.charAt(0).toUpperCase() + str.slice(1);
        }
        return '';
    };

    return (
        <Typography
            align="left"
            variant="body2"
            className={`inlineErrorMessage ${classes.errorMsg} ${classFontSize}`}
        >
            {sanitizeContent(formatStringValue(error))}
        </Typography>
    );
};

InlineErrorMessage.propTypes = {
    error: PropTypes.string.isRequired,
    classes: PropTypes.object.isRequired,
    fontSize: PropTypes.string,
};

InlineErrorMessage.defaultProps = {
    fontSize: 'small',
};

export default withStyles(styles)(InlineErrorMessage);
